import { Stack, Image, Text } from "@fluentui/react";

import bcLogo from '../../../../Assets/Images/BusinessCentral_scalable.svg';
import { lgProvisioningMessageImageStyles, mdProvisioningMessageImageStyles, provisioningMessageContainerStyles, provisioningMessageImageStyles, smProvisioningMessageImageStyles, xlProvisioningMessageImageStyles, xxlProvisioningMessageImageStyles, smProvisioningTitleStyles, mdProvisioningTitleStyles, lgProvisioningTitleStyles, xlProvisioningTitleStyles, xxlProvisioningTitleStyles, smProvisioningSubTitleStyles, mdProvisioningSubTitleStyles, lgProvisioningSubTitleStyles, xlProvisioningSubTitleStyles, xxlProvisioningSubTitleStyles, titleProvisioningStyles, subProvisioningTitleStyles } from "../Styles/CustomerDashboardStyles";
import { BreakpointType } from "../../../Common/Container/ContainerFluid";
import { useBreakpoint } from "../../../Common/Container/ContainerStyles";
import { CustomerService } from "../../../../ApplicationCode/Customer/CustomerService";
import { Trans } from "react-i18next";

export const ProvisioningInProgress: React.FC = (props) => {
    const isXXL = useBreakpoint(BreakpointType.xxl);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isMD = useBreakpoint(BreakpointType.md);
    const isSM = useBreakpoint(BreakpointType.sm);
    
    return(
        <Stack
            verticalFill
            verticalAlign="start"
            horizontalAlign="center"
            className={provisioningMessageContainerStyles}
        >
            <Stack
                hidden={isSM || isMD}
            >
                <Image 
                    src={bcLogo}
                    styles={
                        isSM ?
                            smProvisioningMessageImageStyles :
                        isMD ?
                            mdProvisioningMessageImageStyles :
                        isLG ?
                            lgProvisioningMessageImageStyles :
                        isXL ?
                            xlProvisioningMessageImageStyles :
                        isXXL ?
                            xxlProvisioningMessageImageStyles
                        :
                            provisioningMessageImageStyles
                    }
                />
            </Stack>
            <Stack
                verticalFill
                verticalAlign="center"
                horizontalAlign={"center"}
            >
                <Stack>
                    <Text 
                        className={
                            isSM ? 
                                smProvisioningTitleStyles : 
                            isMD ? 
                                mdProvisioningTitleStyles : 
                            isLG ?
                                lgProvisioningTitleStyles :
                            isXL ?
                                xlProvisioningTitleStyles :
                            isXXL ?
                                xxlProvisioningTitleStyles
                            :
                                titleProvisioningStyles
                        }
                    >
                        {CustomerService.translate("provisioningInProgress:title")}
                    </Text>
                </Stack>
                <Stack>
                    <Text 
                        className={
                            isSM ? 
                                smProvisioningSubTitleStyles : 
                            isMD ? 
                                mdProvisioningSubTitleStyles :
                            isLG ?
                                lgProvisioningSubTitleStyles :
                            isXL ?
                                xlProvisioningSubTitleStyles :
                            isXXL ?
                                xxlProvisioningSubTitleStyles
                            :
                                subProvisioningTitleStyles
                        }
                    >
                        <Trans 
                            i18nKey={"customerCenter:provisioningInProgress:description"}
                            components={[<strong />]}
                        />
                    </Text>
                </Stack>
            </Stack>
        </Stack>
    );
}